import * as React from 'react';
import { Checkbox as FabricCheckbox } from '@fluentui/react/lib/Checkbox';
import { ComponentContext } from '../../../Context/ComponentContext';
import { UsageEventName, EventType } from '../../../Models';
export function Checkbox(props) {
    const { onChange, name, usageEvent } = props;
    const { telemetryClient } = React.useContext(ComponentContext);
    const handleChanged = (e, value) => {
        var _a;
        const checkedEvent = Object.assign({ eventName: UsageEventName.CheckBoxChanged, type: EventType.User, businessTransactionId: (value === null || value === void 0 ? void 0 : value.toString()) || 'null' }, usageEvent);
        const customProps = ((_a = props.logCustomProperties) === null || _a === void 0 ? void 0 : _a.call(props)) || {};
        telemetryClient.trackEvent(checkedEvent, customProps);
        onChange(name, value);
    };
    return React.createElement(FabricCheckbox, Object.assign({}, props, { onChange: handleChanged }));
}
//# sourceMappingURL=Checkbox.js.map